import React, { useCallback } from 'react';

import BaseAgGridTable from 'Components/AgGrid/BaseAgGridTable';
import { handleDeleteFlightTicket } from 'Helpers/FlightTicketHelper';
import { DS_F2W_Business_Travel_Team } from 'Constants/F2wRolesConstants';
import { useDarkMode } from 'Hooks/useDarkMode';
import {
  textColumn,
  firstName,
  lastName,
  destination,
  country,
  iataCode,
  season,
  staffSourceMarket,
  confirmedFlightDate,
  plannedAssignmentStartDate,
  typeOfFlight,
  assignmentType,
} from 'Components/AgGrid/commonColumnDefs';

const DeleteActionCell = ({ data, gridRef, datasourceFactory, dispatch }) => {
  return (
    <button
      className="btn btn-danger btn-sm"
      style={{ margin: '0 5px', padding: '0.5% 1%', borderRadius: '5px', cursor: 'pointer', fontSize: '0.8rem' }}
      onClick={() => handleDeleteFlightTicket(data.id, gridRef, datasourceFactory, dispatch)}
    >
      Delete
    </button>
  );
};

const deleteAction = (gridRef, datasourceFactory, dispatch) => ({
  headerName: 'Actions',
  cellRenderer: (params) => {
    return (
      <DeleteActionCell
        data={params.data}
        gridRef={gridRef}
        datasourceFactory={datasourceFactory}
        dispatch={dispatch}
      />
    );
  },
});

const getColumns = (gridRef, datasourceFactory, dispatch) => [
  textColumn('Status', 'status'),
  assignmentType(),
  firstName(),
  lastName(),
  destination(),
  country(),
  iataCode(),
  season(),
  staffSourceMarket(),
  confirmedFlightDate(),
  plannedAssignmentStartDate(),
  typeOfFlight(),
  deleteAction(gridRef, datasourceFactory, dispatch),
];

const StatusAllAgGridTable = () => {
  const { darkMode } = useDarkMode();

  const getRowStyle = useCallback(
    (params) => {
      if (params.data?.confirmedStatus?.toLowerCase() === 'modified') {
        return { background: darkMode ? '#5a4a3a' : '#fcdab6' };
      }
      if (params.data?.confirmedStatus?.toLowerCase() === 'cancelled') {
        return { background: darkMode ? '#5a3a3a' : '#fcaeae' };
      }
      if (params.data?.status?.toLowerCase() === 'confirmed') {
        return { background: darkMode ? '#3a5a4a' : '#c9f2d6' };
      }
      return { background: darkMode ? '#2e2e2e' : '' };
    },
    [darkMode]
  );

  return (
    <BaseAgGridTable
      endpoint="staff/agGridTable/All"
      viewName="StatusAll"
      statusPath="all"
      columns={getColumns}
      roleToCheckForActions={DS_F2W_Business_Travel_Team}
      getRowStyle={getRowStyle}
    />
  );
};

export default StatusAllAgGridTable;
